import { Validator } from '../../Validator';
import { ValidatorInterface } from '../../ValidatorInterface';
import { ValidatorRegistry } from '../../ValidatorRegistry';
import { PropertiesInterface } from '../Property';
import { ITypeValidatesRequiredIf } from './ITypeValidatesRequiredIf';

export class RequiredIfValidator
  implements ValidatorInterface<ITypeValidatesRequiredIf>
{
  name = 'RequiredIf';

  friendlyName = 'Required Field When';

  arrayOnly = false;

  array = false;

  description = 'shared.properties.validators.requiredIf.description';

  types = null;

  properties = {
    value: {
      type: 'Key',
      default: '',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  } as PropertiesInterface;

  constructor(public config?: Validator) {}

  attach(type: ITypeValidatesRequiredIf) {
    type.addRequiredIfValidator(this);
  }
}

const requiredIfValidator = new RequiredIfValidator(undefined);

ValidatorRegistry.register(RequiredIfValidator, requiredIfValidator.name);

export { requiredIfValidator };
